import styled from 'styled-components';

export const SectionBlock = styled.section`
  padding: 4.5rem 1.5rem;
  background: ${({ theme, $dark, $alt }) =>
    $dark ? theme.colors.nearBlack : $alt ? theme.colors.offWhite : theme.colors.white};
  color: ${({ theme, $dark }) => ($dark ? '#fff' : theme.colors.textPrimary)};
`;

export const Inner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${({ $hasImage }) => ($hasImage ? '1.1fr 1fr' : '1fr')};
  gap: ${({ $hasImage }) => ($hasImage ? '3rem' : '0')};
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

export const SectionTitle = styled.h2`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: clamp(1.6rem, 3vw, 2.3rem);
  color: ${({ $dark }) => ($dark ? '#fff' : '#111')};
  margin-bottom: 1rem;

  span {
    color: ${({ theme }) => theme.colors.goldDark};
    font-style: italic;
  }
`;

export const SectionEyebrow = styled.div`
  font-size: 0.75rem;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  color: ${({ theme, $dark }) => ($dark ? theme.colors.goldLight : theme.colors.goldDark)};
  font-weight: 600;
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;

  &::before {
    content: '';
    width: 34px;
    height: 2px;
    background: ${({ theme }) => theme.colors.gold};
  }
`;

export const Body = styled.div`
  color: ${({ theme, $dark }) => ($dark ? 'rgba(255,255,255,0.78)' : theme.colors.textMuted)};
  font-size: 1rem;
  line-height: 1.85;

  p { margin-bottom: 1rem; }
`;

export const ItemList = styled.ul`
  margin-top: 1.5rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 0.75rem;

  li {
    display: flex;
    align-items: center;
    gap: 0.85rem;
    padding: 0.9rem 1rem;
    border: 1px solid ${({ theme, $dark }) => ($dark ? 'rgba(200,169,81,0.25)' : theme.colors.border)};
    background: ${({ theme, $dark }) => ($dark ? 'rgba(255,255,255,0.03)' : theme.colors.white)};
    font-size: 0.95rem;
    color: ${({ theme, $dark }) => ($dark ? 'rgba(255,255,255,0.88)' : theme.colors.textPrimary)};
    transition: ${({ theme }) => theme.transitions.base};

    &:hover {
      border-color: ${({ theme }) => theme.colors.gold};
      transform: translateX(4px);
    }
  }

  .num {
    flex-shrink: 0;
    width: 32px; height: 32px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.gold};
    color: ${({ theme }) => theme.colors.nearBlack};
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: ${({ theme }) => theme.fonts.heading};
    font-weight: 700;
    font-size: 0.8rem;
  }
`;

export const ImageBlock = styled.div`
  position: relative;
  aspect-ratio: 4 / 3;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &::before {
    content: '';
    position: absolute;
    top: 20px; left: -20px;
    width: 100%; height: 100%;
    border: 3px solid ${({ theme }) => theme.colors.gold};
    z-index: -1;
  }

  .ph {
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.colors.offWhite};
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: ${({ theme }) => theme.fonts.heading};
    font-size: 5rem;
    color: ${({ theme }) => theme.colors.border};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    &::before { display: none; }
  }
`;
